import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"

export function companyTradeHistoryOptions(companyId: number) {
	return queryOptions({
		queryKey: ["companies", companyId, "trading", "history"],
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/trading/history", {
				params: { path: { company_id: companyId } },
			}),
		enabled: companyId > 0,
	})
}

export function useCompanyTradeHistory(companyId: number, enabled: boolean) {
	return useQuery({
		...companyTradeHistoryOptions(companyId),
		enabled: enabled && companyId > 0,
	})
}
